
  import { defineComponent, computed } from 'vue';
  import { ButtonProps, Button } from '@/ui/components/Button';

  interface FilterButtonProps extends ButtonProps {
    count: number;
    tooltiped?: boolean;
    classes?: string | string[];
  }

  export default defineComponent<FilterButtonProps>({
    components: { Button },
    props: ['count', 'type', 'tooltiped', 'classes'],
    setup(props) {
      const pack = computed(() => props.count > 0 ? 'fas' : 'far');
      const tooltipActive = computed(() => props.tooltiped ?? false);

      return {
        pack,
        tooltipActive,
      };
    },
  });
